import { BodyText, FlexContainer } from '@placer-ui/components';
import React from 'react';
import classNames from 'classnames';
import styles from './chip-list.module.scss';

export type ChipListOptionType<T> = {
    label: string;
    value: T;
    testId: string;
    description?: string;
};

interface ChipListProps<Type> {
    testId: string;
    options: ChipListOptionType<Type>[];
    onItemClick: (option: ChipListOptionType<Type>) => void;
}

export const ChipList = <Type,>({ options, onItemClick, testId }: ChipListProps<Type>) => {
    const someOptionWithDescription = options.some((option) => !!option.description);

    return (
        <FlexContainer testId={testId} flexDirection="column" gap={8}>
            {options.map((option) => {
                const { label, description, testId: optTestId } = option;

                return (
                    <button
                        key={label}
                        data-testid={optTestId}
                        aria-label={label}
                        onClick={() => onItemClick(option)}
                        className={classNames(styles.chipListItem, {
                            [styles.withDescription]: !!description,
                        })}
                    >
                        <FlexContainer
                            height={someOptionWithDescription ? 36 : 'unset'}
                            justifyContent="center"
                            flexDirection="column"
                        >
                            <BodyText
                                element="p"
                                size={someOptionWithDescription ? 'default' : 'small'}
                                variant={someOptionWithDescription ? 'semi-bold' : 'regular'}
                                testId={`${optTestId}-label`}
                            >
                                {label}
                            </BodyText>
                            {description && (
                                <BodyText
                                    element="p"
                                    size="small"
                                    color="secondary"
                                    testId={`${optTestId}-description`}
                                >
                                    {description}
                                </BodyText>
                            )}
                        </FlexContainer>
                    </button>
                );
            })}
        </FlexContainer>
    );
};
